import React from "react";
import { SelectOption, Text } from "@showitinc/showit-wc";

import Input from "../../../base/Input";
import WP from "../../../../constants/WP";
import ElementActions from "../../../../components/elementproperties/ElementActions";
import { initFormatter } from "../../../../utils/PropertyFormatters";
import { SELECT } from "../../../../constants/InputConstants.mjs";
import { MIXED } from "../../../../constants/DesignConstants.mjs";
import { prepareInputUtils } from "../../../../utils/InputUtils";
import { IS_FIELD, WP_FIELD, WP_PROPS } from "../../../../constants/PropNames";

const PLACEHOLDERS = [{ key: "", label: "None" }, ...WP.PLACEHOLDERS];

const onPlaceholderColumnUpdate = (element, onPropUpdate) => {
  const updates = ElementActions.buildColumnUpdates(element);
  updates.forEach((update) => onPropUpdate(update));
};

const WPOptions = ({ options = [] }) =>
  options.map(({ key, label }) => (
    <SelectOption key={key} value={key}>
      {label}
    </SelectOption>
  ));

const OtherProps = ({ onPropUpdate, preparedElement, isLocked, field }) => {
  if (field === "post_date") {
    const { onChange: onSelect } = initFormatter(onPropUpdate);
    const format = preparedElement.getIn(["wp", "format"], "F j, Y");

    return (
      <Input
        disabled={isLocked}
        inputType={SELECT}
        key="format"
        label="Date Format"
        onSISelect={onSelect("wp.format", format)}
        reserveContext
        shift="left"
        value={format}
      >
        <WPOptions options={WP.DATE_FORMATS} />
      </Input>
    );
  }
  return null;
};

const TextWPProperties = (props) => {
  const { onPropUpdate, element, preparedElement, isLocked } = props;

  const _onFieldChange = (propInfo) => {
    if (!propInfo.value) {
      propInfo.name = "wp";
      propInfo.value = null;
    } else {
      onPlaceholderColumnUpdate(element, onPropUpdate);
    }

    onPropUpdate(propInfo);
  };

  const { onChange: onSelect } = initFormatter(_onFieldChange);
  const { isMixed, prepareValue } = prepareInputUtils(undefined, preparedElement);

  const field = prepareValue(WP_FIELD, isMixed(WP_PROPS) ? MIXED : "");
  const active = !prepareValue(IS_FIELD) && !isMixed(IS_FIELD);

  return (
    active && (
      <>
        <Text className="panel-subheading">Wordpress</Text>
        <Input
          disabled={isLocked}
          inputType={SELECT}
          key="field"
          label="Placeholder"
          helpTooltip="text-properties-placeholder"
          onSISelect={onSelect("wp.field", field)}
          reserveContext
          shift="left"
          value={field}
        >
          <WPOptions options={PLACEHOLDERS} />
        </Input>
        <OtherProps {...props} field={field} />
      </>
    )
  );
};

export default TextWPProperties;
